<template>
  <v-dialog
    v-model="userStore.addEditdialog"
    max-width="500px"
    class="elevation-0"
    scrollable
    :persistent="userStore.dialogLoading"
    overlay-opacity="0.6"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="userData.role === 'COMMAN'"
        v-bind="attrs"
        v-on="on"
        class="text-capitalize"
        color="secondary"
        depressed
        rounded
      >
        Kullanıcı Ekle
      </v-btn>
    </template>

    <v-card
      rounded="xl"
      flat
      :disabled="userStore.dialogLoading"
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <h4 class="text-body-1 text-sm-h6 font-weight-bold">
          {{ userStore.addEditFormTitle }}
        </h4>

        <v-spacer />

        <v-btn
          color="error"
          small
          outlined
          class="mx-4 text-capitalize"
          rounded
          v-if="
            userStore.editedIndex > -1 &&
            userData.role === 'COMMAN' &&
            userStore.editedItem.member_profile === 'COMUSR'
          "
          :loading="userStore.deleteLoading"
          @click="userStore.deleteItem()"
        >
          <v-icon left>{{ icons.mdiTrashCan }}</v-icon> Sil
        </v-btn>
        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          rounded
          small
          depressed
          color="chip"
          class="text-capitalize"
          @click="userStore.closeItem"
        >
          <v-icon left>{{ icons.mdiClose }}</v-icon>
          Kapat
        </v-btn>
        <v-icon v-else small @click="userStore.closeItem">{{
          icons.mdiClose
        }}</v-icon>
      </v-card-title>

      <v-divider />
      <v-card-text
        ref="scrollableEl"
        class="pa-0 pa-sm-3 pb-0 pt-3"
        style="height: 80dvh"
        :style="
          !$vuetify.breakpoint.smAndUp
            ? 'max-height: 485px'
            : 'max-height: 615px'
        "
      >
        <validation-observer ref="form">
          <v-container class="pb-0">
            <v-row>
              <v-col cols="12" md="12" v-if="userData.role !== 'COMMAN'">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required"
                >
                  <v-select
                    v-model="userStore.editedItem.member_profile"
                    :items="userStore.profileList"
                    disabled
                    label="Profil"
                    rounded
                    filled
                    hide-details="auto"
                    :error-messages="errors"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6" v-if="userStore.editedIndex === -1">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.cari_kod"
                    label="Cari Kod"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6" v-if="userStore.editedIndex === -1">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.adrnums"
                    label="Adres Numarası"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6" v-if="userStore.editedIndex === -1">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.ad"
                    label="Ad"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6" v-if="userStore.editedIndex === -1">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.soyad"
                    label="Soyad"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required|email"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.mail"
                    label="E-Posta"
                    type="email"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.telnum"
                    label="Telefon"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="userStore.editedItem.cashform_branch_name"
                  label="Şube Adı"

                  rounded
                  filled
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="userStore.editedItem.cashform_account"
                  label="100'lu Hesap"
                  rounded
                  filled
                  hide-details
                />
              </v-col>

              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  :rules="{ required: true, regex: /^[a-zA-Z0-9._]*$/ }"
                >
                  <v-text-field
                    :error-messages="errors"
                    v-model="userStore.editedItem.username"
                    label="Kullanıcı Adı"
                    rounded
                    filled
                    hide-details="auto"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  tag="div"
                  mode="eager"
                  :rules="userStore.editedIndex > -1 ? '' : 'required'"
                >
                  <v-text-field
                    @click:append="showPassword = !showPassword"
                    :error-messages="errors"
                    v-model="userStore.editedItem.sifre"
                    :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                    :type="showPassword ? 'text' : 'password'"
                    :label="'Şifre'"
                    :placeholder="
                      userStore.editedIndex > -1
                        ? 'Şifre değiştirmek için doldurun'
                        : ''
                    "
                    autocomplete="new-password"
                    rounded
                    filled
                    hide-details="auto"
                /></validation-provider>
              </v-col>
              <v-col v-if="!$vuetify.breakpoint.smAndUp">
                <v-switch
                  v-model="userStore.editedItem.aktif"
                  class="mt-0 pt-0 ml-3"
                  inset
                  color="secondary"
                  :label="
                    userStore.editedItem.aktif
                      ? 'Kullanıcı Durumu Aktif'
                      : 'Kullanıcı Durumu Pasif'
                  "
                ></v-switch>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="userStore.editedItem.emailto"
                  label="E-Posta TO"
                  rows="3"
                  rounded
                  class="rounded-xl"
                  filled
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="userStore.editedItem.emailcc"
                  label="E-Posta CC"
                  rows="3"
                  rounded
                  class="rounded-xl"
                  filled
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="userStore.editedItem.emailbcc"
                  label="E-Posta BCC"
                  rows="3"
                  rounded
                  class="rounded-xl"
                  filled
                  hide-details
                />
              </v-col>
            </v-row>
          </v-container>
        </validation-observer>
      </v-card-text>
      <v-card-actions class="pa-0 pa-sm-3 pt-0">
        <v-container class="pt-0" style="z-index: 2">
          <v-row align="center">
            <v-col cols="12" :sm="userStore.editedIndex > -1 ? 7 : 12">
              <v-btn
                color="secondary"
                depressed
                rounded
                block
                x-large
                :loading="userStore.saveLoading"
                class="text-capitalize"
                @click="saveItem()"
              >
                {{ userStore.editedIndex > -1 ? "Güncelle" : "Kaydet" }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="5"
              v-if="userStore.editedIndex > -1 && $vuetify.breakpoint.smAndUp"
            >
              <v-switch
                v-model="userStore.editedItem.aktif"
                hide-details
                class="mt-0 pt-0 ml-3"
                inset
                color="secondary"
                :label="userStore.editedItem.aktif ? 'Aktif' : 'Pasif'"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch, toRefs, onMounted } from "vue-demi";

// Pinia
import { useUserStore } from "./_store";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";

// Icons
import { mdiClose, mdiTrashCan, mdiEye, mdiEyeOff } from "@mdi/js";

export default {
  setup() {
    // Pinia
    const userStore = useUserStore();
    const userData = JSON.parse(localStorage.getItem("userData"));
    const scrollableEl = ref(null);

    // Kaydırma çubuğu
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);
    onMounted(() => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const form = ref(null);
    const saveItem = async () => {
      const item = userStore.editedItem;
      ["mail", "username", "sifre"].forEach((k) => {
        if (typeof item[k] === "string") item[k] = item[k].trim();
      });
      const isValid = await form.value.validate();

      const messages = Object.values(form.value.errors || {})
        .flat()
        .filter(Boolean);

      userStore.saveItem(isValid, messages);
    };
    const showPassword = ref(false);

    watch(
      () => userStore.addEditdialog,
      (val) => {
        if (!val) {
          form.value.reset();
        } else {
        }
      }
    );

    return {
      userData,
      userStore,
      scrollableEl,
      form,
      saveItem,
      showPassword,
      isScroll,
      arrivedState,
      // icons
      icons: {
        mdiClose,
        mdiTrashCan,
        mdiEye,
        mdiEyeOff,
      },
    };
  },
};
</script>
./_userListStore
